import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductItemComponent } from './product-item/product-item.component';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { CartItemComponent } from './cart-item/cart-item.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [ProductItemComponent, CartItemComponent],
  exports: [ProductItemComponent, CartItemComponent],
  imports: [
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    IonicModule,
    TranslateModule.forChild(),
    CommonModule,
    RouterModule,
  ]
})
export class SharedModule { }
